import './SelectUserType.css'
import {SignUpWelcomeJsonInterface} from "views/SignInFlow/SignInFlowJson";

interface SignUpUserTypeProps extends React.HTMLAttributes<HTMLDivElement> {
  userTypeJson: SignUpWelcomeJsonInterface
}

function SignUpUserType(props: SignUpUserTypeProps) {
  const {userTypeJson, ...rest} = props;

  return (
    <div className={'user-type'} {...rest}>
      <img src={userTypeJson.img} alt={userTypeJson.userType} className={'user-type-img'}/>
      <div className={'user-type-text-container'}>
        <p className={"user-type-text"}>
          {userTypeJson.userType}
        </p>
        <p className={"user-type-description"}>
          {userTypeJson.description}
        </p>
      </div>
    </div>
  )
}

export default SignUpUserType;
